import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { SolicitudRegistrarRenovacionDocumentoModel } from 'src/app/models/commands/solicitudes/solicitud-persona/SolicitudRegistrarRenovacionDocumentoModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { FilterSolicitudPersonaRenovarDocumentoModel } from 'src/app/models/queries/solicitudes/solicitud-persona/FilterSolicitudPersonaRenovarDocumento';
import { SolicitudPersonaDocumentoPorVencerModel } from 'src/app/models/queries/solicitudes/solicitud-persona/SolicitudPersonaDocumentoPorVencerModel';
import { SolicitudPersonaDocumentosService } from 'src/app/services/solicitud-persona-documentos/solicitud-persona-documentos.service';
import { SolicitudPersonaRenovarDocumentoDialogComponent } from '../../dialogs/solicitud-persona-renovar-documento-dialog/solicitud-persona-renovar-documento-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { SedeService } from 'src/app/services/sede/sede.service';

@Component({
  selector: 'app-solicitud-contratista-documento-por-vencer-lista',
  templateUrl: './solicitud-contratista-documento-por-vencer-lista.component.html',
  styleUrls: ['./solicitud-contratista-documento-por-vencer-lista.component.css']
})
export class SolicitudContratistaDocumentoPorVencerListaComponent implements OnInit {
  modelFilter: FilterSolicitudPersonaRenovarDocumentoModel;
  modelLista: SolicitudPersonaDocumentoPorVencerModel[];
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  resultsLength = 0;
  currentPage = 0;

  @ViewChild('paginator') paginator!: MatPaginator;
  
  displayedColumns: string[] = [
    'compania',
    'trabajador',
    'nroDocumentoIdentidad',
    'fechaVencimiento',
    'documentoRequerido',
    'sede',
    'codigo',
    'acciones',
  ];
  
  constructor(
    private solicitudDocumentoService: SolicitudPersonaDocumentosService,
    public dialog: MatDialog,
    private sedeService: SedeService,
    private storage: StorageService
  ) { 
    this.modelLista = new Array<SolicitudPersonaDocumentoPorVencerModel>();
    this.modelFilter = new FilterSolicitudPersonaRenovarDocumentoModel();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.modelFilter.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.companiaChanged();
    this.search();    
  }

  companiaChanged() {

    this.listaSedes = [];
    this.modelFilter.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.modelFilter.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  addDays(currentDate: Date, days: number): Date {
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }  

  search(): void {
    this.modelFilter.page = 1;
    this.solicitudDocumentoService.getListDocumentosPorVencerPorContratista(this.modelFilter).subscribe((data: SearchResultModel<SolicitudPersonaDocumentoPorVencerModel[]>) => {
      this.modelLista = data.items;
      this.resultsLength = data.total;
      this.currentPage = 0;
      this.paginator.firstPage();
    });
  }

  getPaginatorData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.solicitudDocumentoService
      .getListDocumentosPorVencerPorContratista(this.modelFilter)
      .subscribe(
        (data: SearchResultModel<SolicitudPersonaDocumentoPorVencerModel[]>) => {
          this.modelLista = data.items;
          this.resultsLength = data.total;
        }
      );
  } 

  renovar(model: SolicitudPersonaDocumentoPorVencerModel){
    let documento = new SolicitudRegistrarRenovacionDocumentoModel();    
    documento.idSolicitudPersonaDocumento = model.idSolicitudPersonaDocumento;
    documento.idSolicitud = model.solicitudPersona.solicitud.idSolicitud;
    documento.codigoSolicutd = model.solicitudPersona.solicitud.codigo;
    documento.fechaVencimiento = new Date();
    // console.log(documento);
    const dialogRef = this.dialog.open(SolicitudPersonaRenovarDocumentoDialogComponent, {
      width: '500px',
      // data: { name: this.name, animal: this.animal}
      data: documento
    });    

    dialogRef.afterClosed().subscribe(result => {
      this.search();
    });
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.solicitudDocumentoService.getListDocumentosPorVencerPorContratistaToExport(this.modelFilter).subscribe(
      (data) => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `documentos-por-vencer-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      },
      (error) => {
        //  this.isImageLoading = false;
        //  console.log(error);
      }
    );
  }
}
